module.exports = __webpack_public_path__ + "static/media/membership2025-child.832ed042.png";